// Map Blocks to DatoCMS _modelApiKey
export enum BUTTONS {
  "ButtonExternal" = "button_external",
  "ButtonInternal" = "button_internal",
  "ButtonWithImageExternal" = "button_with_image_external",
  "ButtonWithImageInternal" = "button_with_image_internal",
  "ButtonHeaderTypeAExternal" = "button_header_type_a_external",
  "ButtonHeaderTypeAInternal" = "button_header_type_a_internal"
}
